module.exports = __webpack_public_path__ + "static/media/kairos.9836c992.png";